module.exports = __webpack_public_path__ + "static/media/interrogatSvg.3aa9317e.svg";